// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__n8fg3","options":"AnswerScale_options__1DIL5","selected":"AnswerScale_selected__2eQpm"};